module.exports = __webpack_public_path__ + "img/DSC_0003.6a800e8b.jpg";